import React, { FunctionComponent, ReactNode } from 'react'
import styles from './style.module.css'
import { useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'

export interface FormWrapperProps {
  children: ReactNode
}

export const FormWrapper: FunctionComponent<FormWrapperProps> = ({ children }) => {
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  if (isArcadeDesignLanguage) {
    return <>{children}</>
  }

  return <div className={styles.formWrapper}>{children}</div>
}
